import * as RMenu from '@radix-ui/react-dropdown-menu';
import { Check } from 'lucide-react';
import type { ComponentPropsWithoutRef } from 'react';
import { cn } from '@/lib/cn';

export const DropdownMenu = RMenu.Root;
export const DropdownMenuTrigger = RMenu.Trigger;
export const DropdownMenuRadioGroup = RMenu.RadioGroup;

export function DropdownMenuContent({ className, ...props }: ComponentPropsWithoutRef<typeof RMenu.Content>) {
  return (
    <RMenu.Portal>
      <RMenu.Content
        sideOffset={8}
        collisionPadding={12}
        className={cn(
          'z-50 min-w-56 animate-pop-in rounded-2xl border border-line bg-surface p-1.5 text-ink shadow-lift',
          className,
        )}
        {...props}
      />
    </RMenu.Portal>
  );
}

const itemBase =
  'flex cursor-pointer select-none items-center gap-2.5 rounded-xl px-3 py-2.5 text-sm outline-none transition-colors data-[highlighted]:bg-hover';

export function DropdownMenuItem({
  className,
  danger,
  ...props
}: ComponentPropsWithoutRef<typeof RMenu.Item> & { danger?: boolean }) {
  return (
    <RMenu.Item
      className={cn(itemBase, danger && 'text-danger-600 data-[highlighted]:bg-danger-50 dark:text-red-300 dark:data-[highlighted]:bg-red-500/10', className)}
      {...props}
    />
  );
}

export function DropdownMenuRadioItem({ className, children, ...props }: ComponentPropsWithoutRef<typeof RMenu.RadioItem>) {
  return (
    <RMenu.RadioItem className={cn(itemBase, className)} {...props}>
      {children}
      <RMenu.ItemIndicator className="ml-auto">
        <Check className="size-4 text-action" />
      </RMenu.ItemIndicator>
    </RMenu.RadioItem>
  );
}

export function DropdownMenuLabel({ className, ...props }: ComponentPropsWithoutRef<typeof RMenu.Label>) {
  return <RMenu.Label className={cn('px-3 py-1.5 text-xs font-medium uppercase tracking-wide text-ink-muted', className)} {...props} />;
}

export function DropdownMenuSeparator({ className, ...props }: ComponentPropsWithoutRef<typeof RMenu.Separator>) {
  return <RMenu.Separator className={cn('my-1.5 h-px bg-line', className)} {...props} />;
}
